import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import { clearBusinessToolFloaterRiskState, fetchBusinessPolicyToolFloaterListAsync } from "../../../../../../redux/businessPolicy/businessPolicyToolFloater/businessPolicyToolFloaterActions";

export const useBusinessPolicyToolFloater = (customerPolicyId?: number) => {
  const dispatch = useDispatchWrapper();
  const ToolFloaterList = useSelector(
	(storeState: IStoreState) => storeState.business.toolFloater.data
  );

  const toolFloaterDropdown = React.useMemo(() => {
	return ToolFloaterList.map((item) => {
	  return {
		label:
		  item.incremental_number,
		value: item.incremental_number || "",
	  };
	});
  }, [ToolFloaterList]);

 const refreshData = () => {
	if (customerPolicyId) {
		dispatch(fetchBusinessPolicyToolFloaterListAsync(Number(customerPolicyId), "ACTIVE"));
	  }
 }

  React.useEffect(() => {
	if (customerPolicyId) {
	  dispatch(fetchBusinessPolicyToolFloaterListAsync(Number(customerPolicyId), "ACTIVE"));
	}
	return () => {
	  dispatch(clearBusinessToolFloaterRiskState());
	};
  }, []);

  return { toolFloaterDropdown, refreshData };
};
